exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-analytics-report-inspector-styles__switch {\n  margin: 0 15px;\n  border-radius: 15px;\n  width: 50px;\n  height: 30px;\n  cursor: pointer;\n}\n\n.src-analytics-report-inspector-styles__switchCircle {\n  background: var(--cps-color-bumble);\n  height: 28px;\n  width: 28px;\n  border-radius: 50%;\n  margin: 1px;\n}\n", ""]);

// exports
exports.locals = {
	"switch": "src-analytics-report-inspector-styles__switch",
	"switchCircle": "src-analytics-report-inspector-styles__switchCircle"
};